import { Observable, BehaviorSubject } from "rxjs";
import { Order } from "./order.model";
import {
  OrderFactoryPeriodSummary,
  OrderFactoryProductSummary,
  OrderFactoryDayOfWeekSummary,
  OrderFactoryEventSummary,
  OrderFactoryVenueSummary,
  OrderFactoryCitySummary
} from "./analytics/summaries/summary.abstract";
import {
  OrderFactoryEventData,
  OrderFactoryVenueData,
  OrderFactoryCityData,
  OrderFactoryDayOfWeekData,
  OrderFactoryProductData
} from "./analytics/data/data.abstract";
import { HttpClient } from "@angular/common/http";
import * as moment from "moment";
import { TimeframeFilter } from "../timeframe/timeframes";
import { ProductType } from "../product/enums/product-type.enum";
import {
  AdminDrinkPayoutSummaryBuilder,
  AdminVenuePayoutSummaryBuilder
} from "../export/export.service";
export enum DayOfWeek {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday
}

export class OrderFactoryAnalytics {
  private timeframe: string;
  private _orders: Map<string, Map<string, Order>>;
  private _drinkOrders: Map<string, Map<string, Order>>;

  private period: OrderFactoryPeriodSummary;
  private product: OrderFactoryProductSummary;
  private dow: OrderFactoryDayOfWeekSummary;
  private event: OrderFactoryEventSummary;
  private venue: OrderFactoryVenueSummary;
  private city: OrderFactoryCitySummary;

  private event$$: BehaviorSubject<OrderFactoryEventData[]>;
  private venue$$: BehaviorSubject<OrderFactoryVenueData[]>;
  private city$$: BehaviorSubject<OrderFactoryCityData[]>;
  private dow$$: BehaviorSubject<OrderFactoryDayOfWeekData[]>;
  private period$$: BehaviorSubject<OrderFactoryPeriodSummary>;
  private product$$: BehaviorSubject<OrderFactoryProductData[]>;

  constructor() {
    this.product$$ = new BehaviorSubject<OrderFactoryProductData[]>(null);
    this.period$$ = new BehaviorSubject<OrderFactoryPeriodSummary>(null);
    this.dow$$ = new BehaviorSubject<OrderFactoryDayOfWeekData[]>(null);
    this.event$$ = new BehaviorSubject<OrderFactoryEventData[]>(null);
    this.venue$$ = new BehaviorSubject<OrderFactoryVenueData[]>(null);
    this.city$$ = new BehaviorSubject<OrderFactoryCityData[]>(null);
  }

  public get period$(): Observable<OrderFactoryPeriodSummary> {
    return this.period$$.asObservable();
  }

  public get product$(): Observable<OrderFactoryProductData[]> {
    return this.product$$.asObservable();
  }
  public get dow$(): Observable<OrderFactoryDayOfWeekData[]> {
    return this.dow$$.asObservable();
  }
  public get event$(): Observable<OrderFactoryEventData[]> {
    return this.event$$.asObservable();
  }
  public get venue$(): Observable<OrderFactoryVenueData[]> {
    return this.venue$$.asObservable();
  }
  public get city$(): Observable<OrderFactoryCityData[]> {
    return this.city$$.asObservable();
  }

  public initialize() {
    this.product = new OrderFactoryProductSummary();
    this.period = new OrderFactoryPeriodSummary();
    this.dow = new OrderFactoryDayOfWeekSummary();
    this.event = new OrderFactoryEventSummary();
    this.venue = new OrderFactoryVenueSummary();
    this._orders = new Map();
    this._drinkOrders = new Map();
    this.city = new OrderFactoryCitySummary();
  }

  public async addOrder(order: Order) {
    if (!this._orders.has(order.venue.name))
      this._orders.set(order.venue.name, new Map());
    this._orders.set(
      order.venue.name,
      this._orders.get(order.venue.name).set(order.reference.id, order)
    );
    if (order.product.type == ProductType.Menu) {
      if (!this._drinkOrders.has(order.venue.name))
        this._drinkOrders.set(order.venue.name, new Map());
      this._drinkOrders.set(
        order.venue.name,
        this._drinkOrders.get(order.venue.name).set(order.reference.id, order)
      );
    }
    this.product.add(order);
    this.dow.add(order);
    this.event.add(order);
    this.venue.add(order);
    this.city.add(order);
    this.period.add(order);
  }

  public next() {
    this.city$$.next(this.city.data);
    this.product$$.next(this.product.data);
    this.period$$.next(this.period);
    this.dow$$.next(this.dow.data);
    this.event$$.next(this.event.data);
    this.venue$$.next(this.venue.data);
  }
  public setTimeframe(tf: TimeframeFilter) {
    this.timeframe =
      moment(tf.begin.toDate()).format("MM/DD/YY") +
      " - " +
      moment(tf.end.toDate()).format("MM/DD/YY");
  }

  private get orders(): Map<string, Order>[] {
    return Array.from(this._orders.values()).sort((a, b) => b.size - a.size);
  }
  private get drinkOrders(): Map<string, Order>[] {
    return Array.from(this._drinkOrders.values()).sort(
      (a, b) => b.size - a.size
    );
  }
  onAdminVenuePayoutSummaryPressed(http: HttpClient) {
    let builder = new AdminVenuePayoutSummaryBuilder(
      this.orders,
      this.timeframe,
      http
    );
    builder.start();
  }
  onAdminDrinkPayoutSummaryPressed(http: HttpClient) {
    let builder = new AdminDrinkPayoutSummaryBuilder(
      this.drinkOrders,
      this.timeframe,
      http
    );
    builder.start();
  }
}
